import React from 'react';

export const MdInventory = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M20 2H4C3 2 2 3 2 4v3.01C2 7.73 2.43 8.35 3 8.7V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1-1-2-2-2zm-5 12H9v-2h6v2zm5-8H4V4h16v2z" />
  </svg>
);
